module.exports = __webpack_public_path__ + "img/bg_login.278d6b55.png";